document.addEventListener('DOMContentLoaded', () => {
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'CODE', 'PRE', 'TEXTAREA']);

  function fixWidowsInText(text) {
  if (!text) return text;

  return text
    .replace(/(^|\s)(dla|by|[aiouwzAIUOWZ])\s+/gi, '$1$2\u00A0')

    // 2025 roku -> 2025&nbsp;roku
    .replace(/\b(\d{4})\s+(roku|r\.)\b/gi, '$1\u00A0$2')

    // liczba + słowo -> 4&nbsp;godziny, 16&nbsp;godzin
    .replace(
      /\b(\d+)\s+([A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]+)/g,
      '$1\u00A0$2'
    )

    .replace(
      /\b(w|z|i|a|dla|by)\s+([A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż0-9]+(?:[-–][A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż0-9]+)*)/gi,
      (match, p1, p2) => {
        const fixed = p2.replace(/-/g, '\u2011');
        return p1 + '\u00A0' + fixed;
      }
    );
}

  function walk(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const fixed = fixWidowsInText(node.nodeValue);

      if (fixed !== node.nodeValue) {
        node.nodeValue = fixed;
      }

      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (SKIP_TAGS.has(node.tagName)) return;

    for (const child of node.childNodes) {
      walk(child);
    }
  }

  function applyNoWidows(selector = '[data-nowidows], .js-nowidows') {
    document.querySelectorAll(selector).forEach(el => walk(el));
  }

  applyNoWidows();
});